import {FunctionalComponent } from 'preact';
import { JSXInternal } from 'preact/src/jsx';
import cn from 'classnames';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import styles from './styles.module.scss';

const MoreButton: FunctionalComponent<JSXInternal.HTMLAttributes<HTMLButtonElement>> = (props: JSXInternal.HTMLAttributes<HTMLButtonElement>) => (
  <button
    {...props}
    className={cn(styles.moreBtn, props.className)}
  >
    <MoreVertIcon />
  </button>
);

export default MoreButton;